<template>
  <div class="result-container">
    <header class="top-content">
      <h1>C-GRAN Web</h1>
      <div class="divider-line"></div>
      <img class="logo" src="../assets/logo.png" alt="" width="140px" />
    </header>
    <div class="result-main-content">
      <section class="process-content content">
        <h3>Processing...</h3>
        <h4>
          Currently: {{ module }}
          <i v-show="percentage < 100" class="el-icon-loading" />
        </h4>
        <el-progress
          :text-inside="true"
          :stroke-width="26"
          :percentage="percentage"
        ></el-progress>
      </section>
      <section class="result-content content" v-show="percentage === 100">
        <h3>Results</h3>
        <div class="analysis">
          <h4>Co-occurrence Analysis Result：</h4>
          <el-button
            @click="downloadTaskFile('Co-occurrence Analysis Result')"
            :loading="fileLoading"
            >Download<i class="iconfont el-icon-download"
          /></el-button>
        </div>
        <div class="compound">
          <h4>Compound Annotation Result：</h4>
          <el-tag v-if="resultCount">Shows: {{
            resultCount < 5 ? resultCount : 5
          }}</el-tag>
          <el-tag type="success" style="margin-left: 8px">Total: {{ resultCount }}</el-tag>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
          header-row-class-name="table-header"
        >
          <el-table-column prop="Round" label="Round" align="center">
          </el-table-column>
          <el-table-column prop="ID" label="ID" align="center">
          </el-table-column>
          <el-table-column prop="Seed Node" label="Seed Node" align="center">
          </el-table-column>
          <el-table-column label="Structure" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.Structure" alt="" srcset="" width="100%" />
            </template>
          </el-table-column>
          <el-table-column label="CID" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.CID" target="_blank">{{
                getLastId(scope.row.CID)
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="MonoIsotopic Weight"
            label="MonoIsotopic Weight"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="SMILES" label="SMILES" align="center">
          </el-table-column>
          <el-table-column prop="Formula" label="Formula" align="center">
          </el-table-column>
          <el-table-column prop="Score" label="Score" align="center">
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 24px">
          <el-button @click="downloadTaskFile('Compound Annotation Result')"
            >Download<i class="iconfont el-icon-download"
          /></el-button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      taskId: "",
      eventSource: null,
      percentage: 0,
      resultCount: 0,
      module: "",
      tableData: [],
      fileLoading: false,
    };
  },
  mounted() {
    this.taskId = this.$route.query.id;
    this.getTaskStream();
  },
  methods: {
    getTaskStream() {
      this.eventSource = new EventSource(
        `https://cgran.acemap.info/api/v1/parameter/stream/${this.taskId}`
      );
      // 监听消息事件
      this.eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.status === "running" || data.status === "done") {
          this.percentage = data.progress || 0;
          this.module = data.module;
          this.tableData = data.data || [];
          this.resultCount = data.count || 0;
        }
        if (data.status === "done") {
          this.eventSource.close();
        }
      };

      // 监听自定义事件
      this.eventSource.addEventListener("update", (event) => {
        console.log("自定义更新事件:", event.data);
      });

      // 监听错误事件
      this.eventSource.onerror = (error) => {
        console.error("EventSource错误:", error);
        this.eventSource.close(); // 主动关闭连接
        this.$notify.error({
          title: "Error",
          message: "Error!Please try again!",
        });
      };
    },
    downloadTaskFile(type) {
      if (type === "Co-occurrence Analysis Result") {
        this.fileLoading = true;
      }
      this.$axios
        .get(`https://cgran.acemap.info/api/v1/download`, {
          params: { upload_id: this.taskId, file_type: type },
          responseType: "blob", // 关键：指定响应类型为二进制
        })
        .then((res) => {
          // 从响应头获取文件名（如果后端支持）
          const contentDisposition = res.headers["content-disposition"];
          const fileName = contentDisposition
            ? contentDisposition.split("filename=")[1]
            : `File-${type}`;

          this.downloadFileFromBlob(res.data, fileName, type);
          if (type === "Co-occurrence Analysis Result") {
            this.fileLoading = false;
          }
        })
        .catch(() => {
          if (type === "Co-occurrence Analysis Result") {
            this.fileLoading = false;
          }
        });
    },

    // 通用Blob下载方法
    downloadFileFromBlob(blobData, fileName) {
      // 创建临时URL
      const url = window.URL.createObjectURL(
        new Blob([blobData], {
          type: "text/csv; charset=utf-8",
        })
      );

      // 创建隐藏的下载链接
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      link.style.display = "none";

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理资源
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // 释放内存
    },
    getLastId(url) {
      const parts = url.split("/");
      const lastSegment = parts[parts.length - 1];
      return lastSegment;
    },
  },
};
</script>
<style lang="less" scoped>
.result-container {
}
.top-content {
  position: relative;
  h1 {
    font-weight: 800;
    font-size: 44px;
    font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
    padding: 12px 24px;
  }
  .divider-line {
    height: 6px;
    border-bottom: 2px solid rgb(68 114 196);
    border-top: 2px solid rgb(68 114 196);
  }
  .logo {
    position: absolute;
    top: -40px;
    right: 20px;
  }
}
.result-main-content {
  margin: auto;
  max-width: 1980px;
  padding: 24px;
}
.content {
  padding: 24px;
  h3 {
    font-size: 24px;
    margin-bottom: 18px;
    font-weight: 500;
  }
}
.process-content {
  background-color: rgb(222 235 247);
  margin-bottom: 36px;
  h4 {
    font-size: 18px;
    margin-bottom: 18px;
  }
}
.result-content {
  background-color: rgb(255 242 204);
  .analysis {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
  }
  .compound {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }
  h4 {
    font-weight: 500;
    font-size: 18px;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
  }
  .el-button {
    margin-left: 36px;
    background: #ffd966;
    box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.15);
    font-size: 17px;
    &:hover {
      color: #000;
    }
    .iconfont {
      margin-left: 12px;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .el-table {
    color: #000;
    font-size: 16px;
    a {
      //   color: #2f75b6;
    }
  }
}
</style>
<style lang="less">
.process-content {
  .el-progress-bar__outer {
    border-radius: 8px;
    background-color: #fff !important;
    box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.15);
  }
  .el-progress-bar__inner {
    border-radius: 8px;
    background: linear-gradient(90deg, #ffe4dc, #ffad8a);
  }
}
.result-content {
  .el-table--border,
  .el-table--group {
    border: 1px solid #050505 !important;
  }
  .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #050505;
  }
  .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 1px solid #050505;
  }
}
.table-header {
  font-weight: 900;
  color: #000;
  font-size: 17px;
}
</style>